
import React, { useState, useEffect } from "react"; 
import "../styles/styles.css";
import styled from "styled-components";
import SalesForm from "./SalesForm";
import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
} from "firebase/firestore";
import { fetchCountFromBDMSecuredByEmail, fetchNBCountFromBDMByEmail, fetchImageRankingFromBDM} from "../services/airtable";

import { auth, db } from "../firebase"; // Import auth and db from firebase
import { query, where } from "firebase/firestore"; // Import Firestore functions

// NEW STYLED COMPONENT FOR THE DROPDOWN CONTAINER
const DropdownContainer = styled.div`
  position: absolute;
  height: 120px; /* Increased height */
  top: 80px; /* Push the dropdown down */
  left: 1130px; /* Push the dropdown to the left */
  z-index: 1000;

  /* Dropdown styling */
  select {
    width: 200px; /* Set a fixed width */
    height: 40px; /* Increased height */
    padding: 8px 12px; /* Add padding */
    font-size: 16px; /* Increase font size */
    font-family: "Arial", sans-serif; /* Use a clean font */
    color: #333; /* Text color */
    background-color: #fff; /* Background color */
    border: 2px solid #ccc; /* Add a border */
    border-radius: 8px; /* Rounded corners */
    outline: none; /* Remove default outline */
    cursor: pointer; /* Show pointer cursor */
    transition: all 0.3s ease; /* Smooth transitions */

    /* Hover effect */
    &:hover {
      border-color: #007bff; /* Change border color on hover */
      box-shadow: 0 0 8px rgba(0, 123, 255, 0.3); /* Add a subtle shadow */
    }

    /* Focus effect */
    &:focus {
      border-color: #007bff; /* Change border color on focus */
      box-shadow: 0 0 8px rgba(0, 123, 255, 0.5); /* Add a stronger shadow */
    }

    /* Option styling */
    option {
      font-size: 16px; /* Increase font size for options */
      padding: 8px 12px; /* Add padding to options */
      background-color: #fff; /* Background color for options */
      color: #333; /* Text color for options */
      transition: background-color 0.3s ease; /* Smooth transitions */

      /* Hover effect for options */
      &:hover {
        background-color: #f0f0f0; /* Change background color on hover */
      }
    }
  }
`;
const RowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: ${(props) => (props.isSecondRow ? "-50px 5px" : "0 -15px")};


  @media (max-width: 480px) {
    flex-direction: column;
    margin: 0;
  }
`;

const GaugeContainer = styled.div`
  position: relative;
  top: 25px;
  width: ${(props) =>
    props.isSecondRow
      ? props.size === "mediumLarge"
        ? "270px"
        : "250px"
      : props.size === "large"
      ? "300px"
      : props.size === "mediumLarge"
      ? "240px"
      : "280px"};
  height: ${(props) =>
    props.isSecondRow
      ? props.size === "mediumLarge"
        ? "270px"
        : "250px"
      : props.size === "large"
      ? "300px"
      : props.size === "mediumLarge"
      ? "240px"
      : "200px"};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

     @media (max-width: 545px) {
     order: ${(props) =>
       props["data-gauge-index"] === 1 ? -1 : props["data-gauge-index"] === 0 ? 0 : 1};
   }

  &:hover .remove-button {
    display: flex;
  }
    &:hover .add-button {
    display: flex;
  } 
     &:hover .update-button {
    display: flex;
  }
  margin: ${(props) =>
    props.isSecondRow
      ? `0 ${props.secondRowGap || "-10px"}`
      : "10px 10px"};

      margin: ${(props) =>
    props["data-gauge-index"] === 0 || props["data-gauge-index"] === 1 || props["data-gauge-index"] === 2
      ? "10px -5px" 
      : props.isSecondRow
      ? `0 ${props.secondRowGap || "-10px"}`
      : "10px 10px"};
`;

const AddButton = styled.button`
  position: absolute;
  top: 0px;
  right: 45px;
  display: none;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #388e3c;
  }
`;
const UpdateButton = styled.button`
position: absolute;
top: 0px;
right: 80px;
display: none;
background: #ffa726;
color: white;
border: none;
border-radius: 50%;
width: 28px;
height: 28px;
justify-content: center;
align-items: center;
cursor: pointer;
font-size: 14px;

&:hover {
  background: #fb8c00;
}
`;  

const RemoveButton = styled.button`
  position: absolute;
  top: 0px;
  right: 0px;
  display: none;
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  width: 25px;
  height: 28px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: #d9363e;
  }
`;

const CenteredContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: "Arial", sans-serif;
  font-size: 0.9rem;
  color: #333;

  .title {
    font-size: 1rem;
    font-weight: bold;
    line-height: 1.2;
    color: #333;
    text-align: center;
    word-wrap: break-word;

    .line-break {
      display: block;
      margin-top: 0.3rem;
    }
  }

  .number {
    font-size: 1.8rem;
    font-weight: bold;
    margin-top: 5px;
    color: #f7941d;
    position: absolute;
    bottom: -75px;
  }

  .text-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;


const formatNumberForDisplay = (number) => {
  if (typeof number === "number" || !isNaN(number)) {
    const parsedNumber = parseFloat(number);

    if (parsedNumber >= 1000000) {
      const value = parsedNumber / 1000000;
      return Number.isInteger(value) ? `${value}M` : `${value.toFixed(1)}M`;
    } else if (parsedNumber >= 1000) {
      const value = parsedNumber / 1000;
      return Number.isInteger(value) ? `${value}k` : `${value.toFixed(1)}k`;
    }
  }
  return number;
};

const generateYellowArc = (rangeFrom, rangeTo, value, adjustedRadius, circleCenter, gaugeIndex) => {
  if (gaugeIndex === 22) {
    value = Math.max(1, Math.min(value, 3));
    rangeFrom = 1;
    rangeTo = 3;  

    if (value === 1) {
      const startAngle = 130;
      const endAngle = 181;
      const startRadian = (startAngle * Math.PI) / 180;
      const endRadian = (endAngle * Math.PI) / 180;

      const startX = circleCenter + adjustedRadius * Math.cos(startRadian);
      const startY = circleCenter + adjustedRadius * Math.sin(startRadian);
      const endX = circleCenter + adjustedRadius * Math.cos(endRadian);
      const endY = circleCenter + adjustedRadius * Math.sin(endRadian);
      const largeArcFlag = 0; 

      return `M ${startX} ${startY} A ${adjustedRadius} ${adjustedRadius} 0 ${largeArcFlag} 1 ${endX} ${endY}`;
    }

    if (value === 3) {
      const startAngle = 130;
      const endAngle = 360;
      const startRadian = (startAngle * Math.PI) / 180;
      const endRadian = (endAngle * Math.PI) / 180;
      const startX = circleCenter + adjustedRadius * Math.cos(startRadian);
      const startY = circleCenter + adjustedRadius * Math.sin(startRadian);
      const endX = circleCenter + adjustedRadius * Math.cos(endRadian);
      const endY = circleCenter + adjustedRadius * Math.sin(endRadian);
      const largeArcFlag = 1; 

      return `M ${startX} ${startY} A ${adjustedRadius} ${adjustedRadius} 0 ${largeArcFlag} 1 ${endX} ${endY}`;
    }
  }

  const totalRange = rangeTo - rangeFrom;

  const startAngle = 135; 
  let endAngle = 135 + ((value - rangeFrom) / totalRange) * 270;

  endAngle = Math.min(endAngle, 405);
  const startRadian = (startAngle * Math.PI) / 180;
  const endRadian = (endAngle * Math.PI) / 180;

  const startX = circleCenter + adjustedRadius * Math.cos(startRadian);
  const startY = circleCenter + adjustedRadius * Math.sin(startRadian);
  const endX = circleCenter + adjustedRadius * Math.cos(endRadian);
  const endY = circleCenter + adjustedRadius * Math.sin(endRadian);

  const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;

  return `M ${startX} ${startY} A ${adjustedRadius} ${adjustedRadius} 0 ${largeArcFlag} 1 ${endX} ${endY}`;
};

const CircularGauge = ({
  title,
  number,
  size,
  isSecondRow,
  gaugeIndex,
  onRemove,
  onAdd,
  onUpdate,
  rangeFrom,
  rangeTo,
  interval,
  tickMarks,
}) => {
  const radius = size === "large" ? 90 : size === "mediumLarge" ? 85 : 75;
  const adjustedRadius = isSecondRow ? radius + 5 : radius;
  const circleCenter = 100;

  const renderTicks = () => {
    const ticks = [];
    const numbers = [];
    const startAngle = 135;
    const endAngle = 405;
    const totalTicks = Math.floor((rangeTo - rangeFrom) / interval) + 1;
    const angleIncrement = (endAngle - startAngle) / (totalTicks - 1);
    const isCompactMode = totalTicks >= 25;
    const numberFontSize = isCompactMode ? 8 : 10;
    const tickGap = isCompactMode ? 10 : 15;
    const numberGap = isCompactMode ? 20 : 28;

    for (let i = 0; i < totalTicks; i++) {
      const value = rangeFrom + i * interval;
      const angle = startAngle + i * angleIncrement;
      const radian = (angle * Math.PI) / 180;
      const x1 = circleCenter + (adjustedRadius - 2) * Math.cos(radian);
      const y1 = circleCenter + (adjustedRadius - 2) * Math.sin(radian);
      const x2 = circleCenter + (adjustedRadius - tickGap) * Math.cos(radian);
      const y2 = circleCenter + (adjustedRadius - tickGap) * Math.sin(radian);

      ticks.push(
        <line
          key={`tick-${i}`}
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke="#000"
          strokeWidth={i % Math.floor(totalTicks / tickMarks) === 0 ? "2" : "1"}
        />
      );

      const xText = circleCenter + (adjustedRadius - numberGap) * Math.cos(radian);
      const yText = circleCenter + (adjustedRadius - numberGap) * Math.sin(radian);

      numbers.push(
        <text
          key={`number-${i}`}
          x={xText}
          y={yText}
          fontSize={numberFontSize}
          textAnchor="middle"
          fill="#333"
          fontFamily="Arial"
        >
          {formatNumberForDisplay(value)}
        </text>
      );
    }

    return { ticks, numbers };
  };

  const { ticks, numbers } = renderTicks();
  const parsedNumber = parseFloat(
    String(number).replace(/[^0-9.]/g, "")
  ) * (String(number).includes("M") ? 1e6 : 1);
  
  const clampedNumber = Math.min(Math.max(parsedNumber, rangeFrom), rangeTo);
  


const yellowArcPath = generateYellowArc(
  rangeFrom,
  rangeTo,
  clampedNumber,
  adjustedRadius,
  circleCenter,
  gaugeIndex // Pass the gaugeIndex to handle the "Tier" case
);
  

  const formattedTitle = ["Leads to Sales", "Portfolio #", "Image Ranking", "PUM's Referral", "Lead Conversion", "Office Ranking", "PUM's in Core", "Live Listings"].includes(title)
    ? title.split(" ")
    : [title];

  return (
    <GaugeContainer size={size} isSecondRow={isSecondRow}>
      <RemoveButton className="remove-button" onClick={onRemove}>
        ×
      </RemoveButton>
      <AddButton className="add-button" onClick={onAdd}>
        +
      </AddButton>
      <UpdateButton className="update-button" onClick={() => onUpdate(gaugeIndex)}>
        ✎
      </UpdateButton>
      <svg width="100%" height="100%" viewBox="0 0 200 200">
        <mask id={`gaugeMask${gaugeIndex}`}>
          <rect x="0" y="0" width="200" height="200" fill="white" />
          <rect 
            x="0" 
            y={
              gaugeIndex === 2 || gaugeIndex === 3 
                ? "156"
                : gaugeIndex === 1
                ? "163"
                : "163"
            } 
            width="200" 
            height="100" 
            fill="black" 
          />
        </mask>
        <circle
          cx={circleCenter}
          cy={circleCenter}
          r={adjustedRadius}
          fill="none"
          stroke="#e0e0e0"
          strokeWidth="3"
          mask={`url(#gaugeMask${gaugeIndex})`}
        />
             {yellowArcPath && (
          <path
            d={yellowArcPath}
            fill="none"
            stroke="#f7941d"
            strokeWidth="3"
          />
        )}
        {ticks}
        {numbers}
      </svg>
      <CenteredContent size={size} title={title}>
        <div className="text-container">
          <div className="title">
            {title === "Average % Fee" ? (
              <>
                Average %
                <span className="line-break">Fee</span>
              </>
            ) : title === "Forms 6s Signed" ? (
              <>
                Forms 6s
                <span className="line-break">Signed</span>
              </>
            ) : (
              formattedTitle.map((line, index) => <div key={index}>{line}</div>)
            )}
          </div>
          <div className="number">{number}</div>
        </div>
        <div className="text-container">
          <div className="number">
            {formatNumberForDisplay(number)}
          </div>
        </div>
      </CenteredContent>
    </GaugeContainer>
  );
};

const BDM = ({ userEmail }) => {
  const [gauges, setGauges] = useState([
    { title: "Image Ranking", number: "0", size: "mediumLarge", rangeFrom: 0, rangeTo: 110, interval: 10, tickMarks: 20 },
    { title: "New Business (Actual)", number: "0", size: "large", rangeFrom: 0, rangeTo: 1000, interval: 100, tickMarks: 20 },
    { title: "Forms 6s Signed", number: "0", size: "mediumLarge", rangeFrom: 0, rangeTo: 1000, interval: 100, tickMarks: 20 },
    { title: "Average % Fee", number: "0%", size: "medium", rangeFrom: 0, rangeTo: 100, interval: 10, tickMarks: 20 },
  ]);

  const [showPopup, setShowPopup] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [currentGaugeIndex, setCurrentGaugeIndex] = useState(null);

  // NEW STATE: Store BDM users and selected user email
  const [bdmUsers, setBDMUsers] = useState([]);
  const [selectedUserEmail, setSelectedUserEmail] = useState(userEmail); // Default to the passed userEmail

  useEffect(() => {
    const updateGaugesWithFetchedData = async () => {
      try {
        console.log("Fetching data for gauges...");

        // Parallelize API calls
        const [fetchedData, newBusinessData, imageRankingData] = await Promise.all([
          fetchCountFromBDMSecuredByEmail(selectedUserEmail),
          fetchNBCountFromBDMByEmail(selectedUserEmail),
          fetchImageRankingFromBDM(selectedUserEmail),
        ]);

        console.log("Fetched data:", { fetchedData, newBusinessData, imageRankingData });
        setGauges((prevGauges) => {
          const updatedGauges = [...prevGauges];
          if (fetchedData && updatedGauges[2]) {
            updatedGauges[2] = {
              ...updatedGauges[2],
              number: fetchedData.totalCount.toString(),
            };
          }

          if (fetchedData && updatedGauges[3]) {
            updatedGauges[3] = {
              ...updatedGauges[3],
              number: `${fetchedData.avgMgmtFee.toString()}%`,
            };
          }

          if (newBusinessData) {
            const newBusinessGaugeIndex = updatedGauges.findIndex(
              (gauge) => gauge?.title === "New Business (Actual)"
            );

            if (newBusinessGaugeIndex !== -1) {
              updatedGauges[newBusinessGaugeIndex] = {
                ...updatedGauges[newBusinessGaugeIndex],
                number: newBusinessData.totalCount.toString(),
              };
            } else if (updatedGauges[0]) {
              updatedGauges[0] = {
                ...updatedGauges[0],
                number: newBusinessData.totalCount.toString(),
              };
            }
          }

          if (imageRankingData) {
            const imageRankingGaugeIndex = updatedGauges.findIndex(
              (gauge) => gauge?.title === "Image Ranking"
            );

            if (imageRankingGaugeIndex !== -1) {
              updatedGauges[imageRankingGaugeIndex] = {
                ...updatedGauges[imageRankingGaugeIndex],
                number: imageRankingData.toString(),
              };
            } else if (updatedGauges[0]) {
              updatedGauges[0] = {
                ...updatedGauges[0],
                number: imageRankingData.toString(),
              };
            }
          }

          return updatedGauges;
        });
      } catch (error) {
        console.error("Error fetching data from Airtable:", error);
      }
    };

    updateGaugesWithFetchedData();
  }, [selectedUserEmail]); // Re-fetch data when selectedUserEmail changes

  // NEW USE EFFECT: Fetch BDM users on component mount
  useEffect(() => {
    const fetchBDMUsers = async () => {
      try {
        const usersRef = collection(db, "user_accounts");

        // Query for users where Department is either an array containing "BDM" or a string equal to "BDM"
        const q = query(
          usersRef,
          where("Department", "in", ["BDM", ["BDM"]]) // Use "in" to match both cases
        );

        const querySnapshot = await getDocs(q);
        const users = [];
        querySnapshot.forEach((doc) => {
          const userData = doc.data();
          const department = userData.Department;

          // Check if the department is either "BDM" or an array containing "BDM"
          if (
            department === "BDM" ||
            (Array.isArray(department) && department.includes("BDM"))
          ) {
            users.push({
              id: doc.id,
              name: userData.Employee, // Use the "Employee" field for the name
              email: userData.ImageEmail, // Use the "ImageEmail" field for the email
            });
          }
        });

        // Sort users alphabetically by name
        users.sort((a, b) => a.name.localeCompare(b.name));

        console.log("Fetched BDM Users:", users); // Log the fetched users
        setBDMUsers(users);
      } catch (error) {
        console.error("Error fetching BDM users:", error);
      }
    };

    fetchBDMUsers();
  }, []);

  // Handle dropdown selection
  const handleUserSelect = (event) => {
    const selectedEmail = event.target.value;
    setSelectedUserEmail(selectedEmail); // Update the selected user email
  };

  const handleAdd = (index) => {
    setShowPopup(true);
    setIsUpdating(false);
    setCurrentGaugeIndex(index);
  };

  const handleUpdate = (index) => {
    setShowPopup(true);
    setIsUpdating(true);
    setCurrentGaugeIndex(index);
  };

  const handleSubmitNewGauge = (formData) => {
    const { title, number, rangeFrom, rangeTo, interval, tickMarks } = formData;

    if (isUpdating && currentGaugeIndex !== null) {
      const updatedGauges = [...gauges];
      updatedGauges[currentGaugeIndex] = {
        ...updatedGauges[currentGaugeIndex],
        title,
        number,
        rangeFrom: parseInt(rangeFrom, 10),
        rangeTo: parseInt(rangeTo, 10),
        interval: parseInt(interval, 10),
        tickMarks: parseInt(tickMarks, 10),
      };
      setGauges(updatedGauges);
    } else {
      const baseGauge = gauges[currentGaugeIndex] || {};
      const newGauge = {
        title: title || "New Gauge",
        number: number || "0",
        size: baseGauge.size || "medium",
        rangeFrom: parseInt(rangeFrom, 10),
        rangeTo: parseInt(rangeTo, 10),
        interval: parseInt(interval, 10),
        tickMarks: parseInt(tickMarks, 10),
      };

      const updatedGauges = [...gauges];
      const insertIndex = currentGaugeIndex !== null ? currentGaugeIndex + 1 : gauges.length;
      updatedGauges.splice(insertIndex, 0, newGauge);
      setGauges(updatedGauges);
    }

    setShowPopup(false);
  };

  const handleRemove = (index) => {
    const updatedGauges = gauges.filter((_, i) => i !== index);
    setGauges(updatedGauges);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      {/* NEW DROPDOWN CONTAINER */}
      <DropdownContainer>
        <select onChange={handleUserSelect} value={selectedUserEmail}>
          {bdmUsers.map((user) => (
            <option key={user.id} value={user.email}>
              {user.name} {/* Display only the name */}
            </option>
          ))}
        </select>
      </DropdownContainer>

      <RowContainer>
        {gauges.slice(0, 3).map((gauge, index) => (
          <GaugeContainer key={index} size={gauge.size} data-gauge-index={index}>
            <CircularGauge
              {...gauge}
              gaugeIndex={index}
              onRemove={() => handleRemove(index)}
              onAdd={() => handleAdd(index)}
              onUpdate={() => handleUpdate(index)}
            />
          </GaugeContainer>
        ))}
      </RowContainer>

      <RowContainer isSecondRow>
        {gauges.slice(3).map((gauge, index) => (
          <GaugeContainer key={index + 3} size={gauge.size} data-gauge-index={index}>
            <CircularGauge
              {...gauge}
              gaugeIndex={index + 3}
              isSecondRow
              onRemove={() => handleRemove(index + 3)}
              onAdd={() => handleAdd(index + 3)}
              onUpdate={() => handleUpdate(index + 3)}
            />
          </GaugeContainer>
        ))}
      </RowContainer>

      {showPopup && (
        <SalesForm
          onSubmit={(formData) => handleSubmitNewGauge(formData)}
          onClose={handleClosePopup}
          formData={isUpdating && currentGaugeIndex !== null ? gauges[currentGaugeIndex] : {}}
          isUpdateMode={isUpdating}
        />
      )}
    </>
  );
};

export default BDM;